export default __webpack_public_path__ + "static/media/illastration-1.94c67c92.png";